import { render, staticRenderFns } from "./CheckmarkText.vue?vue&type=template&id=7213b10c&"
import script from "./CheckmarkText.vue?vue&type=script&lang=js&"
export * from "./CheckmarkText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports